import axios from "axios"

const {
	REACT_APP_URI_SUPPLIERS: URI_SUPPLIER,
	REACT_APP_URI_SERVER_DATE: URI_SERVER_DATE,
	REACT_APP_URI_USERS_FILTER_BY_DATA_ID: URI_USERS,
	REACT_APP_URI_CLIENT: URI_CLIENT,
	REACT_APP_URI_USERS_FILTER_BY_DATA_ID: URI_USERS_BY_DATA_ID,
	REACT_APP_URI_SUPPLIER_CLIENT_STATUS: URI_SUPPLIER_CLIENT_STATUS,
} = process.env

export const fetchServerDate = async () => {
	const { data } = await axios.get(URI_SERVER_DATE)
	return data
}

export const fetchSupplierById = async (id, { dataID, rol }) => {
	const urlParams = new URLSearchParams({ dataID, rol })
	const { data } = await axios.get(URI_SUPPLIER + id + "?" + urlParams.toString())
	return data
}

export const fetchUsername = async (id) => {
	const { data } = await axios.post(URI_USERS, { idsToFind: [id] })
	return data[0]?.username ?? null
}

export const fetchAllClients = async () => {
	const { data } = await axios.get(URI_CLIENT)
	return data
}

export const fetchSupplierUsers = async (id) => {
	const { data } = await axios.post(URI_USERS_BY_DATA_ID, { idsToFind: [id] })
	return data
}

export const updateClientStatus = async ({ id, clientID, newStatus, username, dataID, rol }) => {
	const { data } = await axios.patch(URI_SUPPLIER_CLIENT_STATUS + id, { clientID, newStatus, username, dataID, rol })
	return data.supplier
}

export const saveSupplierInfo = async ({ supplier, id }) => {
	const date = new Date()
	const year = date.getFullYear()
	const month = date.getMonth() + 1
	const day = date.getDate()

	const formData = new FormData()
	const supplierToSave = supplier

	formData.append("rfc", supplierToSave.informationCompliance.generalInformation.rfc)
	let saveWithFile = false
	const filesToSave = []

	supplierToSave.informationCompliance.generalInformation.cvp.agreements.forEach(agreement => {
		if (!agreement.yearCreatedAt || !agreement.monthCreatedAt || !agreement.dayCreatedAt) {
			agreement.yearCreatedAt = year
			agreement.monthCreatedAt = month
			agreement.dayCreatedAt = day
		}

		if (agreement.document && agreement.document.name) {
			saveWithFile = true
			const fileToSave = agreement.document
			const fileNewName = `${agreement.yearCreatedAt}-${agreement.monthCreatedAt}-${agreement.document.name.normalize("NFD").replace(/[\u0300-\u036f]/g, "")}`
			filesToSave.push({ file: fileToSave, fileNewName: fileNewName })
			agreement.checkThis = true
		}
		agreement.uploadedAt = agreement.uploadedAt ? agreement.document && agreement.document.name ? `${month}/${day}/${year}` : agreement.document ? agreement.uploadedAt : "" : agreement.document && `${month}/${day}/${year}`
		agreement.document = agreement.document && (agreement.document.name ? `${agreement.yearCreatedAt}-${agreement.monthCreatedAt}-${agreement.document.name.normalize("NFD").replace(/[\u0300-\u036f]/g, "")}` : agreement.document)
	})

	if (supplierToSave.informationCompliance.generalInformation.curriculum.document?.name) {
		saveWithFile = true
		const fileToSave = supplierToSave.informationCompliance.generalInformation.curriculum.document
		const fileNewName = `${supplierToSave.informationCompliance.generalInformation.curriculum.yearCreatedAt}-${supplierToSave.informationCompliance.generalInformation.curriculum.monthCreatedAt}-${supplierToSave.informationCompliance.generalInformation.curriculum.document.name.normalize("NFD").replace(/[\u0300-\u036f]/g, "")}`
		filesToSave.push({ file: fileToSave, fileNewName: fileNewName })
		supplierToSave.informationCompliance.generalInformation.curriculum.checkThis = true
	}
	supplierToSave.informationCompliance.generalInformation.curriculum.uploadedAt = supplierToSave.informationCompliance.generalInformation.curriculum.uploadedAt ? supplierToSave.informationCompliance.generalInformation.curriculum.document && supplierToSave.informationCompliance.generalInformation.curriculum.document.name ? `${month}/${day}/${year}` : supplierToSave.informationCompliance.generalInformation.curriculum.document ? supplierToSave.informationCompliance.generalInformation.curriculum.uploadedAt : "" : supplierToSave.informationCompliance.generalInformation.curriculum.document && `${month}/${day}/${year}`
	supplierToSave.informationCompliance.generalInformation.curriculum.document = supplierToSave.informationCompliance.generalInformation.curriculum.document && (supplierToSave.informationCompliance.generalInformation.curriculum.document.name ? `${supplierToSave.informationCompliance.generalInformation.curriculum.yearCreatedAt}-${supplierToSave.informationCompliance.generalInformation.curriculum.monthCreatedAt}-${supplierToSave.informationCompliance.generalInformation.curriculum.document.name.normalize("NFD").replace(/[\u0300-\u036f]/g, "")}` : supplierToSave.informationCompliance.generalInformation.curriculum.document)

	supplierToSave?.staffs?.forEach(staff => {
		if (staff.profilePhoto?.document && staff.profilePhoto?.document.name) {
			saveWithFile = true
			const fileToSave = staff.profilePhoto.document
			const fileNewName = `${staff.profilePhoto.yearCreatedAt}-${staff.profilePhoto.monthCreatedAt}-${staff.profilePhoto.document.name.normalize("NFD").replace(/[\u0300-\u036f]/g, "")}`
			filesToSave.push({ file: fileToSave, fileNewName: fileNewName })
			staff.profilePhoto.checkThis = true
		}
		if (staff.profilePhoto) {
			staff.profilePhoto.uploadedAt = staff.profilePhoto.uploadedAt ? staff.profilePhoto.document && staff.profilePhoto.document.name ? `${month}/${day}/${year}` : staff.profilePhoto.document ? staff.profilePhoto.uploadedAt : "" : staff.profilePhoto.document && `${month}/${day}/${year}`
			staff.profilePhoto.document = staff.profilePhoto.document && (staff.profilePhoto.document.name ? `uploads/${supplierToSave.informationCompliance.generalInformation.rfc}/${staff.profilePhoto.yearCreatedAt}-${staff.profilePhoto.monthCreatedAt}-${staff.profilePhoto.document.name.normalize("NFD").replace(/[\u0300-\u036f]/g, "")}` : staff.profilePhoto.document)
		}

		staff.payrollReceipts.forEach(receipt => {
			if (receipt.document && receipt.document.name) {
				saveWithFile = true
				const fileToSave2 = receipt.document
				const fileNewName2 = `${receipt.yearCreatedAt}-${receipt.monthCreatedAt}-${receipt.document.name.normalize("NFD").replace(/[\u0300-\u036f]/g, "")}`
				filesToSave.push({ file: fileToSave2, fileNewName: fileNewName2 })
				receipt.checkThis = true
			}
			if (receipt) {
				receipt.document = receipt.document && (receipt.document.name ? `${receipt.yearCreatedAt}-${receipt.monthCreatedAt}-${receipt.document.name.normalize("NFD").replace(/[\u0300-\u036f]/g, "")}` : receipt.document)
			}
		})
	});

	supplierToSave.clients.forEach(client => {
		client.contracts.forEach(contract => {
			if (contract.contract.document && contract.contract.document.name) {
				saveWithFile = true
				const fileToSave = contract.contract.document
				const fileNewName = `${year}-${month}-${contract.contract.document.name.normalize("NFD").replace(/[\u0300-\u036f]/g, "")}`
				filesToSave.push({ file: fileToSave, fileNewName: fileNewName })
				contract.contract.checkThis = true
			}
			contract.contract.uploadedAt = contract.contract.uploadedAt ? contract.contract.document && contract.contract.document.name ? `${month}/${day}/${year}` : contract.contract.document ? contract.contract.uploadedAt : "" : contract.contract.document && `${month}/${day}/${year}`
			contract.contract.document = contract.contract.document && (contract.contract.document.name ? `${year}-${month}-${contract.contract.document.name.normalize("NFD").replace(/[\u0300-\u036f]/g, "")}` : contract.contract.document)
		});
	})

	supplierToSave.productsAndServices.products.forEach(product => {
		if (product.drawing.document && product.drawing.document.name) {
			saveWithFile = true
			const fileToSave = product.drawing.document
			const fileNewName = `${product.drawing.yearCreatedAt}-${product.drawing.monthCreatedAt}-${product.drawing.document.name.normalize("NFD").replace(/[\u0300-\u036f]/g, "")}`
			filesToSave.push({ file: fileToSave, fileNewName: fileNewName })
			product.drawing.checkThis = true
		}
		product.drawing.uploadedAt = product.drawing.uploadedAt ? product.drawing.document && product.drawing.document.name ? `${month}/${day}/${year}` : product.drawing.document ? product.drawing.uploadedAt : "" : product.drawing.document && `${month}/${day}/${year}`
		product.drawing.document = product.drawing.document && (product.drawing.document.name ? `${product.drawing.yearCreatedAt}-${product.drawing.monthCreatedAt}-${product.drawing.document.name.normalize("NFD").replace(/[\u0300-\u036f]/g, "")}` : product.drawing.document)

		if (product.picture.document && product.picture.document.name) {
			saveWithFile = true
			const fileToSave = product.picture.document
			const fileNewName = `${product.picture.yearCreatedAt}-${product.picture.monthCreatedAt}-${product.picture.document.name.normalize("NFD").replace(/[\u0300-\u036f]/g, "")}`
			filesToSave.push({ file: fileToSave, fileNewName: fileNewName })
			product.picture.checkThis = true
		}
		product.picture.uploadedAt = product.picture.uploadedAt ? product.picture.document && product.picture.document.name ? `${month}/${day}/${year}` : product.picture.document ? product.picture.uploadedAt : "" : product.picture.document && `${month}/${day}/${year}`
		product.picture.document = product.picture.document && (product.picture.document.name ? `${product.picture.yearCreatedAt}-${product.picture.monthCreatedAt}-${product.picture.document.name.normalize("NFD").replace(/[\u0300-\u036f]/g, "")}` : product.picture.document)
	})

	saveWithFile && filesToSave.forEach(doc => {
		formData.append("document", doc.file, doc.fileNewName)
	})
	formData.append("saveWithFile", saveWithFile)
	formData.append("supplier", JSON.stringify(supplierToSave))

	const { data } = await axios.put(URI_SUPPLIER + id, formData)
	return data.supplier
}
